import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useCallback } from 'react';
import { setCreateGameNumMttSeats, setCreateGameNumSeats } from '../../../redux/actions/createGameActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { ALL_CREATE_ROOM_TYPE_PROPERTIES } from '../../../types/sharedTypes';
import { getAllNumSeatsOptions } from '../../../utils/numSeatsUtils';
export const NumSeatsControlContainer = () => {
    const dispatch = useAppDispatch();
    const roomType = useAppSelector((state) => state.createGame.roomType);
    const isMtt = roomType === 'mtt';
    const numSeats = useAppSelector((state) => (isMtt ? state.createGame.numMttSeats : state.createGame.numSeats));
    const onChange = useCallback((event) => {
        const newNumSeats = Number(event.target.value);
        if (isMtt) {
            dispatch(setCreateGameNumMttSeats(newNumSeats));
        }
        else {
            dispatch(setCreateGameNumSeats(newNumSeats));
        }
    }, [dispatch, isMtt]);
    if (!ALL_CREATE_ROOM_TYPE_PROPERTIES[roomType].hasNumSeatsControl) {
        return null;
    }
    return (_jsxs(FormControl, { variant: 'outlined', children: [_jsx(InputLabel, { children: "Seats" }), _jsx(Select, { "data-testid": 'create-game-num-seats-select', value: `${numSeats}`, label: 'Seats', onChange: onChange, style: {
                    minWidth: '70px',
                    width: '70px'
                }, children: getAllNumSeatsOptions(isMtt).map((currNumSeats) => (_jsx(MenuItem, { value: currNumSeats, children: currNumSeats }, currNumSeats))) })] }));
};
